<template lang="pug">
  .col-24.l-padding-bottom-6em.m-padding-bottom-0
    .c-banner.initBackgroundImage.m-height-40vh(:style="{backgroundImage:'url('+ img.banner +')'}")
    .col-21.flexD.flexDirectionRow.justifySpaceBetween.l-margin-top-4em.m-width-100.m-margin-top-0.m-flexDirectionColumn(style="margin-left: auto; margin-right: auto")
      .c-aboutUs__block.relative.m-width-100-important.flexWrap(v-for="(item, index) in blocks" :key="index")
        .col-24.initBackgroundImage.textAlignLeft.flexD.flexDirectionColumn.alignItemsCenter.justifyCenter(:style="{backgroundImage:'url('+ item.img +')'}")
          p.color-white.textAlignCenter {{ item.title }}
          span.font-section.color-white {{ item.content }}
    .col-24.flexD.alignItemsCenter.justifyCenter.l-margin-top-4em.m-margin-top-2em
      .col-16.flexD.flexDirectionRow.justifySpaceBetween.m-width-100.m-flexDirectionColumn
        .col-17.m-width-100.m-padding-left-right-5p.m-margin-bottom-2em
          .font-section.textAlignLeft {{ des }}
        .col-6.m-width-100
          img.block.col-24.m-height-30vh.objectFitCover(:src="img.image")
</template>

<script>
  export default {
    name: 'teamWork',
    props: ['content'],
    data(){
      return{
        blocks: [
          { title: this.$t('about_us.title_1'), content: this.$t('about_us.content_1'), img: require('@/assets/img/about_us_1.jpg') },
          { title: this.$t('about_us.title_2'), content: this.$t('about_us.content_2'), img: require('@/assets/img/about_us_2.jpg') },
          { title: this.$t('about_us.title_3'), content: this.$t('about_us.content_3'), img: require('@/assets/img/about_us_3.jpg') },
        ],
        des: this.$t('about_us.des'),
        img: {
          banner: require('@/assets/img/banner_about_us.png'),
          image: require('@/assets/img/about_us_4.png')
        }
      }
    },
    computed: {},
    methods:{},
    created(){}
  }
</script>
